/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{z-index:11}footer[_ngcontent-%COMP%]   .footer-center[_ngcontent-%COMP%]{padding:0}footer[_ngcontent-%COMP%]   .footer-center[_ngcontent-%COMP%]   .link[_ngcontent-%COMP%]{cursor:pointer}.footer-container[_ngcontent-%COMP%]{padding:.5rem 1rem}.fa-warning[_ngcontent-%COMP%]{color:red;cursor:pointer}"];
export { styles as styles };
